// thx arco.design
// delete keys from object
export function omit(obj, keys) {
    const clone = {
        ...obj,
    };
    keys.forEach((key) => {
        if (key in clone) {
            delete clone[key];
        }
    });
    return clone;
}
//# sourceMappingURL=omit.js.map